import { limitSummerTires, limitWinterTires, recommendedSummerTires, recommendedWinterTires } from 'noddi-util';

export type TireWearInfoTranslations = {
  title: string;
  goodCondition: string;
  shouldBeReplaced: string;
  mustBeReplaced: string;
  regulationsTitle: string;
  regulationsDescription: string;
};

export type FleetViewTireWearTranslations = {
  summerTitle: string;
  winterTitle: string;
  goodCondition: string;
  shouldBeReplaced: string;
  mustBeReplaced: string;
  regulationsTitle: string;
  summerRegulationsDescription: string;
  winterRegulationsDescription: string;
};

export const winterTireTranslations: TireWearInfoTranslations = {
  title: 'Winter tires',
  goodCondition: 'Good condition',
  shouldBeReplaced: 'Should be replaced',
  mustBeReplaced: 'Must be replaced',
  regulationsTitle: 'Regulations and our recommendations',
  regulationsDescription: `In Norway, the minimum requirement for tread depth on winter tires is ${limitWinterTires} mm. It is illegal to drive with winter tires that are under ${limitWinterTires} mm. We recommend changing tires when the tread depth is below ${recommendedWinterTires} mm. When the tread depth is below ${recommendedWinterTires} mm, the braking distance increases considerably, and the tire loses its performance.`
};

export const summerTireTranslations: TireWearInfoTranslations = {
  title: 'Summer tires',
  goodCondition: 'Good condition',
  shouldBeReplaced: 'Should be replaced',
  mustBeReplaced: 'Must be replaced',
  regulationsTitle: 'Regulations and our recommendations',
  regulationsDescription: `In Norway, the minimum requirement for tread depth on summer tires is ${limitSummerTires} mm. It is illegal to drive with summer tires that are under ${limitSummerTires} mm. We recommend changing tires when the tread depth is below ${recommendedSummerTires} mm. When the tread depth is below ${recommendedSummerTires} mm, the braking distance increases considerably, and the tire loses its performance.`
};
